import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import PersonIcon from '@material-ui/icons/Person';
import Grid from '../../Common/Grid/index';
import getNoDataCellComponent from '../../Common/NoDataCellComponent/index';

import styles from './styles';

const toString = (date) => {
  if (!date) {
    return '';
  }

  if (date.toISOString) {
    return date.toISOString();
  }

  return date;
}

const groupResources = (resources = []) => {
  const grouped = _.groupBy(resources, (resource) => `${toString(resource.from)}-${toString(resource.to)}-${resource.role.id}`);
  const result = _.values(_.mapValues(grouped, (resources) => (_.assign(resources[0], { quantity: resources.length }))));
  return result;
};

const COLUMNS = [
  { name: 'date', title: 'Date' },
  { name: 'hours', title: 'Hours' },
  { name: 'role', title: 'Role' },
  { name: 'quantity', title: 'Quantity' },
  { name: 'action', title: ' ' },
];

const COLUMN_EXTENSIONS = [
  // { columnName: 'name', width: 200 },
  // { columnName: 'mobile', width: 100 },
  // { columnName: 'email', width: 150 },
  // { columnName: 'action', width: 100 },
];

const getCellComponent = ({ row, column, value }) => {
  switch (column.name) {
    case 'date':
      return moment(row.from).format('ll');
    case 'hours':
      return <span>{moment(row.from).format('LT')} - {moment(row.to).format('LT')}</span>
    case 'role':
      return value.name;
    case 'action':
      return null;
    default:
      return value;
  }

};

class ResourceSummaryGrid extends Component {
  state = {};

  render() {
    const { value } = this.props;
    const resources = groupResources(value);

    return (<div>
      <Grid
        columns={COLUMNS}
        columnExtensions={COLUMN_EXTENSIONS}
        cellComponent={getCellComponent}
        fetch={_.noop}
        data={{ data: resources }}
        noDataCellComponent={getNoDataCellComponent(<PersonIcon style={styles.noData}/>, 'resources')}
      />
    </div>);
  }
}

ResourceSummaryGrid.propTypes = {
  // roles: PropTypes.array,
  // initialDate: PropTypes.object,
  value: PropTypes.array.isRequired,
  // onEdit: PropTypes.func.isRequired,
  // onRemove: PropTypes.func,
  // onChange: PropTypes.func.isRequired,
  // showError: PropTypes.func.isRequired,
};

export default ResourceSummaryGrid;



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceSummaryGrid/index.js